module.exports = __webpack_public_path__ + "static/media/ic_church.cc8de5c8.svg";